module.exports = __webpack_public_path__ + "img/LBA-WEB.6a369371.svg";